import React, {useEffect} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../components/AppAnimate";
import {useTranslation} from "react-i18next";
import MakeUser from "../manage/users/MakeUser";
import MakePassword from "../manage/users/MakePassword";
import Title from "../../components/elements/Title";
import {isAdmin, isSupplier} from "../../../config/Permissions";
import {Typography, Box} from "@mui/material";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import LogoutDialog from "../../components/layout/components/LogoutDialog";
import AccountSavedCardsBlock from "./AccountSavedCardsBlock";

const ACCOUNT_FORM_COLUMN_SX = { width: "100%", maxWidth: 480, mx: "auto" };

function AccountDetailsPage({edit,password}){
    const { t } = useTranslation();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    },[]);
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('accountDetails')}>
            <Grid container spacing={2} justifyContent="center">
                {
                    !password &&
                    <>
                        {
                            !!isAdmin() &&
                            <Grid item size={{xs:12,md:10,lg:8}} style={{display:"flex",gap:10,alignItems:"center",justifyContent:"space-between",padding:20,backgroundColor:"#f5fdf4",borderRadius:12,}}>
                                <Typography>
                                    {t('hiAdminGoToPanel')}
                                </Typography>
                                <Button
                                    component={Link}
                                    variant="contained"
                                    color="secondary"
                                    to={"/panel"}
                                    size="small"
                                    style={{width:200}}
                                >
                                    {t('adminPanel')}
                                </Button>
                            </Grid>
                        }
                        {
                            !!isSupplier() &&
                            <Grid item size={{xs:12,md:10,lg:8}} style={{display:"flex",gap:10,alignItems:"center",justifyContent:"space-between",padding:20,backgroundColor:"#f5fdf4",borderRadius:12,}}>
                                <Typography>
                                    {t('hiSupplierGoToPanel')}
                                </Typography>
                                <Button
                                    component={Link}
                                    variant="contained"
                                    color="secondary"
                                    to={"/panel"}
                                    style={{width:200}}
                                    size="small"
                                >
                                    {t('shopPanel')}
                                </Button>
                            </Grid>
                        }
                        <Grid item size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "center" }}>
                            <Box sx={ACCOUNT_FORM_COLUMN_SX}>
                                <Title align="left" color="text">
                                    {t("accountDetails")}
                                </Title>
                                <MakeUser details />
                            </Box>
                        </Grid>
                        <Grid item size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "center" }}>
                            <Box sx={ACCOUNT_FORM_COLUMN_SX}>
                                <Title align="left" color="text">
                                    {t("myCardsPageTitle")}
                                </Title>
                                <AccountSavedCardsBlock />
                            </Box>
                        </Grid>
                    </>
                }

                <Grid item size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "center" }}>
                    <Box sx={ACCOUNT_FORM_COLUMN_SX}>
                        <Title align="left" color="text">
                            {t("password")}
                        </Title>
                        <MakePassword accountColumn />
                    </Box>
                </Grid>
                {
                    !password &&
                    <>
                        <Grid item size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "center" }}>
                            <Box sx={ACCOUNT_FORM_COLUMN_SX}>
                                <Title align="left" color="text">
                                    {t("logout")}
                                </Title>
                                <div
                                    style={{
                                        display: "flex",
                                        gap: 10,
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        padding: 20,
                                        backgroundColor: "#fdf4f5",
                                        borderRadius: 12,
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                >
                                <Typography>
                                    {t('doYouWantToLogout')}
                                </Typography>
                                <Button
                                    variant="outlined"
                                    onClick={() => setDialogOpen(true)}
                                    size="small"
                                    style={{width:150}}

                                >
                                    {t('logout')}
                                </Button>
                                <LogoutDialog logoutOpen={dialogOpen} closeDialog={() => setDialogOpen(false)} />
                            </div>
                            </Box>
                        </Grid>
                    </>
                }

            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(AccountDetailsPage);
